module.exports = __webpack_public_path__ + "static/media/inaugoration1.8be999a0.jpg";